import { LoadingSpinner } from '@paypalcorp/pp-react'
import React from 'react'
import useBreakpoint from 'lib/useBreakpoint'
interface Props {
  className?: string
  isVisible?: boolean
}

const PageLoadingSpinner = ({
  className,
  isVisible = true
}: Props): JSX.Element | null => {
  const { isMobile, isTablet } = useBreakpoint()

  if (!isVisible) return null

  const pageLoadingSpinnerClassName = className
    ? 'page-loading-spinner ' + className
    : 'page-loading-spinner'

  const spinnerClassName = className
    ? 'page-loading-spinner__spinner ' + className + '__spinner'
    : 'page-loading-spinner__spinner'

  const bigSpinnerSize = isTablet ? 'lg' : 'xl'
  const spinnerSize = isMobile ? 'sm' : bigSpinnerSize

  return (
    <div data-cy="loadingSpinner" className={pageLoadingSpinnerClassName}>
      <LoadingSpinner
        className={spinnerClassName}
        screenReaderText="loading"
        size={spinnerSize}
      />
    </div>
  )
}

export default PageLoadingSpinner
